import { useCallback } from 'react'

import { useNavigate } from 'Pods/Shared/ContextBasedRouter'
import usePageConfig from 'Pods/Shared/Hooks/usePageConfig'
import { STUDIO_PATH } from 'Pods/ThreeDStudio/constants'
import useRegenerateImageRun from 'Pods/ThreeDStudio/Hooks/useRegenerateImageRun'
import useRequireLogin from 'Pods/ThreeDStudio/Hooks/useRequireLogin'

// Regenerate for an image opened at /ai-image/:slug, whose `id` is its run id. The backend only
// regenerates the viewer's own runs, so an owner gets a real regenerate while anyone else lands
// on the Image Generator with the image's prompt typed in, to send as their own generation.
// Both end on the Image Generator, closing the modal; the regenerate request survives that
// because its host, ImageDeepLink, renders outside the routes.
//
// Ownership is read from the username: the image payload names its author by username only,
// and usernames are unique. Getting it wrong is harmless, since the backend refuses another
// user's run.
function useImageRegenerate() {
  const navigate = useNavigate()
  const requireLogin = useRequireLogin('login')
  const currentUsername = usePageConfig()?.currentUserUsername
  const { regenerateImage, isLoading } = useRegenerateImageRun()

  const regenerate = useCallback((image) => {
    if (!requireLogin()) return

    const isOwner = Boolean(currentUsername) && currentUsername === image.user?.username
    if (isOwner) {
      regenerateImage(image.id)
      navigate(STUDIO_PATH.IMAGE_GENERATOR)
      return
    }

    navigate(STUDIO_PATH.IMAGE_GENERATOR, { state: { prefillPrompt: image.prompt ?? '' } })
  }, [currentUsername, navigate, regenerateImage, requireLogin])

  return { regenerate, isRegenerating: isLoading }
}

export default useImageRegenerate
